let redirecting = false;

export function handleStaffSessionExpired(status?: number, location: Pick<Location,'pathname'|'replace'> = window.location): boolean {
 if (status !== 401 || window.config?.APP_ENV_NAME !== 'cvparc-shadow') return false;
 if (location.pathname.includes('/login')) return true;
 if (!redirecting) {
  redirecting = true;
  // Keep local message drafts and server-side report drafts intact.
  location.replace('/main/login?expired=1');
 }
 return true;
}
